import { FaroPopover, FaroPopoverProps } from "@faro-lotv/flat-ui";
import type { JSX } from "react";

export type NewFeaturePopupProps = Pick<
  FaroPopoverProps,
  "anchorEl" | "title" | "description" | "onClose" | "placement" | "chipLabel"
>;

/**
 * @returns the component to show the popover for a new feature.
 */
export function NewFeaturePopup({
  anchorEl,
  title,
  description,
  placement,
  onClose,
  chipLabel,
}: NewFeaturePopupProps): JSX.Element | null {
  return anchorEl ? (
    <FaroPopover
      dark
      open
      anchorEl={anchorEl}
      onClose={onClose}
      closeOnClickOutside={false}
      title={title}
      description={description}
      actions={[{ children: "Got it", onClick: onClose }]}
      chipLabel={chipLabel ?? "new"}
      placement={placement}
      sx={{
        // Set the z-index to achieve the following stacking of UI elements:
        //  1) Toasts: snackbar = 1400
        //  2) MainUi > ModalSpinner: snackbar - 1 = 1399
        //  3) Data Management > DataCategoryDialog: snackbar - 2 = 1398
        //  4) ImportDataDialog > Dialog: snackbar - 3 = 1397
        //  5) NewFeaturePopup > FaroPopover: modal + 1 = 1301
        zIndex: (theme) => theme.zIndex.modal + 1,
      }}
    />
  ) : null;
}
